import React from 'react';

const SvgCy = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CY_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CY_svg__b" fill="#fff">
        <use xlinkHref="#CY_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M20.73 2.969c.333-.167.44-.057.239.244l-.605.907c-.2.302-.61.71-.91.911l-.907.605a8.038 8.038 0 0 0-1.017.834l.274-.274a.662.662 0 0 0-.004.937l.4.4a.66.66 0 0 1 0 .933l-.4.401c-.258.258-.736.331-1.07.164l-.126-.062a.675.675 0 0 0-.906.302l-.063.125c-.166.333-.58.697-.934.815l-.735.245c-.35.116-.929.21-1.3.21-.368 0-.8.27-.968.605l-.063.125a.67.67 0 0 1-.893.308l-1.484-.741A4.868 4.868 0 0 1 8.2 10.2l-.4-.4c-.258-.258-.467-.763-.467-1.133 0-.369.302-.667.66-.667H7.34c.364 0 .867-.208 1.125-.466l.401-.401c.258-.258.762-.466 1.133-.466a.98.98 0 0 0 .878-.633l.244-.735a.77.77 0 0 1 .87-.5l2.016.403c.364.072.944.06 1.304-.03l1.376-.344c.356-.09.915-.296 1.25-.463l.124-.063 1.209-.604.125-.063 1.208-.604.125-.062z"
        fill="#E7832C"
        mask="url(#CY_svg__b)"
      />
      <circle fill="#445128" mask="url(#CY_svg__b)" cx={14} cy={15.333} r={1} />
      <path
        d="M16 14.667s2-.667 2.667-2"
        stroke="#445128"
        strokeWidth={1.333}
        opacity={0.75}
        strokeLinecap="round"
        mask="url(#CY_svg__b)"
      />
      <path
        d="M9.333 14.667s2-.667 2.667-2"
        stroke="#445128"
        strokeWidth={1.333}
        opacity={0.75}
        strokeLinecap="round"
        mask="url(#CY_svg__b)"
        transform="matrix(-1 0 0 1 21.333 0)"
      />
    </g>
  </svg>
);

export default SvgCy;
